/**
 * Created by hernanherreros on 2019-05-03
 */

import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import { RouterItem } from '../config/router.config'
import withCongress, { ComponentProps } from '../providers/Congress/withCongress'
import { getRouteConfig, getSteps } from '../helpers/routes'

class FormRouter extends React.Component<ComponentProps> {
  getRoute = (slug?: string) => {
    const { congress } = this.props
    return getRouteConfig(congress.Slug, slug)
  }

  render () {
    return (
      <Switch>
        {this.renderRoutes()}
      </Switch>
    )
  }

  renderRoutes () {
    const { congress } = this.props
    const steps = getSteps(congress.Slug)

    const routerConfig = steps.map(step => {
      return { ...this.getRoute(step) }
    })

    return routerConfig.map((route: RouterItem, index, routes: RouterItem[]) => {
      const nextRoute = { ...routes[index + 1] }

      const Component = route.component
      delete route['component']
      delete nextRoute['component']

      if (Component) {
        return (
          <Route
            exact
            key={route.slug}
            path={route.path || ''}
            component={(props: any) => (
              <Component
                {...props}
                step={route}
                nextStep={nextRoute}
              />
            )}
          />
        )
      } else {
        return null
      }
    })
  }
}

export default withCongress(FormRouter)
